/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('GroupManagerCtrl', ["$rootScope", '$scope', '$http', 'IntentService', 'NetworkService', "MainService", 'Notification', function ($rootScope, $scope, $http, IntentService, NetworkService, MainService, Notification) {

        $scope.mode = 0 //0 == groupView   1 == singleGroupView
        $scope.permissions = []
        $scope.permissionEditMode = false;

        NetworkService.getMitarbeiterDetails(UserId, function (data) {
            $rootScope.$emit("setNavName", data);
        })

        $scope.goBack = function ()
        {
            $scope.mode = 0
            $scope.permissionEditMode = false;
            animateItBack()
        }

        $rootScope.$on("repaint", function () {
            $scope.render()
        });
        $scope.openEditMode = function (veranstaltung_id, Berechtigungslevel)
        {
            $scope.editPermission = {veranstaltung_id: veranstaltung_id,
                group_id: Berechtigungslevel}
            $scope.permissionEditMode = true
        }



        $scope.openRemoveGroupDialog = function (group)
        {
            $rootScope.$emit("updateRemoveGroup", group)
            $("#dialog_removeGroup").modal("open")()
        }
        $scope.removePermission = function (permission)
        {
            NetworkService.removePermission(permission)
            $scope.render()
        }
        $scope.updatePermissions = function ()
        {
          console.log($scope.permissions)
            $scope.permissions.forEach(function (permission) {
                if (isNaN(permission.level))
                {
                    if (permission.level == "lesen")
                    {
                        permission.level = 1
                    } else if (permission.level == "schreiben")
                    {
                        permission.level = 2
                    } else if (permission.level == "verwalten")
                    {
                        permission.level = 3
                    }
                }
                NetworkService.updatePermission(permission, $scope.acualGroup, function (data) {
                    console.log(data)
                })

            })
        }

        $scope.openGroup = function ($event, name)
        {
            $scope.mode = 1
            $scope.acualGroup = name
            $scope.groupId = name
            MainService.setDialogData("dialog_addPermissionToGroupCtrl", {groupId: name})
            animateIt($event)
            NetworkService.getGroupMembers(name, function (data) {
                $rootScope.$emit("setGroupMembers", data)
            })

            NetworkService.getPermissions(name, function (data) {
                $scope.permissions = data
            })
        }

        $scope.openPermissionDialog = function ()
        {
            $("#dialog_addPermissionToGroup").modal("open")()
        }

        $scope.renderPermission = function (level)
        {
            var ret = "-1"
            if (level == 1)
            {
                ret = "lesen"
            } else if (level == 2)
            {
                ret = "schreiben"
            } else if (level == 3)
            {
                ret = "verwalten"
            }else if (level == 1.5)
            {
                ret = "listen-manager"
            }else if (level == 0)
            {
                ret = "registrierung"
            }
            return ret
        }
        $scope.openAddGoupDialog = function ()
        {
            if ($scope.mode == 0)
            {
                $("#dialog_addGroup").modal("open")()
            }
        }

        $scope.initSelect = function () {
            $('select:not([multiple])').material_select();
        }
        $scope.updateUsers = function ()
        {
            $rootScope.$on("getGroupMembersReturn", function (event, data) {
                var users = data.group;
                /*users.forEach(function (el) {
                 var email = el.email
                 NetworkService.addPersonToGroup(email, $scope.groupId, function (el) {
                 })
                 })*/
                NetworkService.updateGroupMembers(users, $scope.groupId, function(d){
                    if(d.done)
                    {
                        Notification.success("Gruppe wurder erfolgreich upgedatet")
                    }
                    else
                    {
                        Notification.error("Es gab einen Fehler: GroupManagerCtrl.updateUsers()")
                    }
                })
            })

            $rootScope.$emit("getGroupMembers")
        }

        $scope.render = function () {
            NetworkService.getGroups(function (data) {
                $scope.groups = data.data
            })
        }


        $(document).ready(function () {
            // Select - Single
            setTimeout(function () {
                $('select:not([multiple])').material_select();
            }, 3000)

            $("#suggests").on("click", function (e) {
                e.stopPropagation()
            })

        });
        $scope.render()


    }])
